import { useState, type ReactNode } from 'react';
import { Sidebar } from './sidebar';
import { Header } from './header';
import { APP_VERSION, BUILD_DATE } from '@/lib/utils';

interface AppShellProps {
  children: ReactNode;
}

/**
 * Main application layout with:
 * - Collapsible sidebar (left)
 * - Top header with user menu
 * - Main content area
 * - Responsive: Sidebar → Hamburger menu on mobile
 *
 * @see Spec 0012 Section 7.1 - App Shell Layout
 */
export function AppShell({ children }: AppShellProps) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="flex min-h-screen bg-background">
      {/* Sidebar */}
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
      />

      {/* Main content area */}
      <div className="flex flex-1 flex-col transition-all duration-300">
        {/* Header */}
        <Header />

        {/* Page content */}
        <main className="flex-1 px-3 pb-3 pt-6 md:px-6 md:pb-4">{children}</main>

        {/* Footer */}
        <footer className="border-t px-4 py-3 text-center text-xs text-muted-foreground/70 md:px-6">
          v{APP_VERSION} · {BUILD_DATE}
        </footer>
      </div>
    </div>
  );
}
